import React from "react";
import logo from "../images/sa.svg";

const Navbar = () => {
  return (
    <>
      <div className="p-2" style={{ background: "rgb(70 108 70)" }} dir="rtl">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-white text-end">
              <a href="tel:+99691028883" className="text-white text-decoration-none">
                 +99691028883
              </a>
            </div>
            <div className="col-md-6 text-white text-start">
              <a href="mailto:elta@gmai.com" className="text-white text-decoration-none">
                 elta@gmai.com
              </a>
            </div>
          </div>
        </div>
      </div>

     <nav className="navbar navbar-expand-lg p-3" dir="rtl">
  <div className="container">
    <a className="navbar-brand " href="/">
     <img src={logo} width="90px" />
    </a>

    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active " href="/">
            الرئيسية
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link " href="#">
            عن الموقع
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link " href="#">
            تواصل معنا
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

    </>
  );
};

export default Navbar;
